import DispatchConstants from '../../constants/DispatchConstants';

import ListingConversion from '../../model/ListingConversion';

const initState = () => ListingConversion();

const propertyConversion = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.UPDATE_PROPERTIES_CONVERSION:
      return Object.assign({}, state, payload);
    default:
      return state;
  }
};

export default propertyConversion;
